import api from '@/api/common/question.js'
const state = {
}
const mutations = {
}
const actions = {
}
for (const key in api) {
    if(api[key].mutationsName) {
        state[api[key].stateName] =  api[key].stateDefaultName || ''
        mutations[api[key].mutationsName] = (state, data) => {
            if(api[key].getStateName) {
                let getStateNameList = api[key].getStateName.split('.')
                let i = 0
                let stateValue = data
                while(i< getStateNameList.length) {
                    stateValue = stateValue[getStateNameList[i]]
                    i++
                }
                state[api[key].stateName] = stateValue
            } else {
                state[api[key].stateName] =  data
            }
        }
    }
    actions[key] = async ({commit}, params = {}) => {
        if(api[key].mutationsName) {
            let res = await api[key].requestFun(params)
            commit(api[key].mutationsName, res)
            return res
        } else {
            return api[key].requestFun(params)
        }
    }
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}